import React, { useState } from 'react';
import { View, Text } from '@tarojs/components';
import * as Taro from '@tarojs/taro';
import { BoardMode } from '@/data/board';
import { WORLD_STAGE_NOTE } from '@/data/boardPatterns';
import { getModeProgress, formatTime } from '@/utils/storage';
import { chinaDateKey } from '@/utils/modeBoards';
import styles from './index.module.scss';

const LevelPage: React.FC = () => {
  const [modes, setModes] = useState(getModeProgress);
  Taro.useDidShow(() => { setModes(getModeProgress()); });
  const enterMode = (mode: BoardMode) => {
    Taro.setStorageSync('selectedLevel', { mode, stage: mode === 'world' ? modes.worldStage : 1 });
    Taro.switchTab({ url: '/pages/game/index' });
  };
  const today = chinaDateKey();
  return (
    <View className={styles.container}>
      <Text className={styles.title}>选择挑战</Text>
      <Text className={styles.description}>每日一关慢慢消，大世界认真规划。</Text>
      <View className={styles.levels}>
        <View className={styles.card} data-board-mode='daily' onClick={() => enterMode('daily')}>
          <View className={styles.cardTop}><Text className={styles.number}>日</Text><View className={styles.nameBlock}><Text className={styles.name}>每日一关</Text><Text className={styles.meta}>原版历史牌型 · 每日更新</Text></View><Text className={styles.status}>去挑战 ›</Text></View>
          <Text className={styles.description}>按历史牌型还原层叠，配牌更轻松，慢慢消除。</Text>
          <Text className={styles.best}>{modes.dailyDates.includes(today) ? '今日已通关 · 最快 ' + formatTime(modes.dailyBest[today] || 0) : '今日尚未通关'}</Text>
        </View>
        <View className={styles.card} data-board-mode='world' onClick={() => enterMode('world')}>
          <View className={styles.cardTop}><Text className={styles.number}>世</Text><View className={styles.nameBlock}><Text className={styles.name}>羊羊大世界</Text><Text className={styles.meta}>{WORLD_STAGE_NOTE}</Text></View><Text className={styles.status}>第{modes.worldStage}关 ›</Text></View>
          <Text className={styles.description}>城堡交替推进，留住辅助牌；卡槽吃紧时用道具腾挪。</Text>
          <Text className={styles.best}>已完成 {modes.worldCompleted.length} 关</Text>
        </View>
      </View>
    </View>
  );
};
export default LevelPage;
